<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <header v-if="displayWidth === 'narrow'">
    <ButtonUser />
    <Logo id="logo" />
    <PrimaryNav />
  </header>
  <header v-else>
    <div id="left-column">
      <div class="profile-and-venue">
        <ButtonUser />
        <MainSponsors :key="`${year}-sponsor`" :year="year" />
      </div>
      <Logo id="logo" />
      <Subtitle />
    </div>
    <!-- <SearchBox /> -->
    <PrimaryNav />
  </header>
</template>

<script setup>
import ButtonUser from "./ButtonUser.vue";
import Logo from "./Logo.vue";
import MainSponsors from "./MainSponsors.vue";
import PrimaryNav from "./Navigation/Primary.vue";
import Subtitle from "./Subtitle.vue";
import {inject, onMounted} from "vue";
//import SearchBox from "./SearchBox.vue";

// eslint-disable-next-line
const props = defineProps({
  year: {default: 0, type: [Number, String]}
});
const displayWidth = inject("displayWidth"); // from useDisplayMode.js

onMounted(() => console.log(`Header mounted`));
</script>

<style scoped>
header {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 10px;
  box-sizing: border-box;
  /* 165–190px at the default 16px; in rem so the nav and title keep their spacing when a
     browser's default font size differs (Firefox 115, 2026-10-15) */
  height: clamp(10.3125rem, 25vw, 11.875rem);
  padding: 0 0.75rem; /* Y, X  0.6rem */
  margin: 0.75rem 0 0.6rem 0; /* Y, X    12px 0px;  */
}
.narrow header {
  height: auto; /* undo height clamp */
  align-items: center;
  column-gap: 5px;
}
#left-column {
  min-width: 0; /* may shrink: the menu always has its room */
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between; /* space-between */
  height: 100%;
  box-sizing: border-fox;
}
.profile-and-venue {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.narrow #logo {
  text-align: center;
  flex: 500; /* expand logo more than others */
}
</style>
